import { Link } from 'react-router-dom';

const LOGO = 'https://static.readdy.ai/image/9ddf36d056944457ba6d11db4bbe63a3/a79f7c4f392dd3eb1e2a6e263a44105a.jpeg';

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="Godwin Logistics" className="w-12 h-12 object-contain bg-white rounded-md p-1" />
              <div>
                <div className="font-heading font-bold text-lg">Godwin Logistics</div>
                <div className="text-xs text-primary-300 uppercase tracking-widest">& Services</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-background-200 leading-relaxed">
              Commissionnaire de transport international spécialisé dans le fret maritime depuis la Chine vers la RDC.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Solutions</h4>
            <ul className="space-y-2 text-sm text-background-200">
              <li><Link to="/solutions" className="hover:text-primary-300 cursor-pointer">Fret FCL / Conteneur Full</Link></li>
              <li><Link to="/solutions" className="hover:text-primary-300 cursor-pointer">Fret LCL / Groupage</Link></li>
              <li><Link to="/solutions" className="hover:text-primary-300 cursor-pointer">House to House</Link></li>
              <li><Link to="/solutions" className="hover:text-primary-300 cursor-pointer">Projets hors gabarit</Link></li>
              <li><Link to="/solutions" className="hover:text-primary-300 cursor-pointer">Gestion douanière</Link></li>
              <li><Link to="/solutions" className="hover:text-primary-300 cursor-pointer">Transaction de fonds</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Entreprise</h4>
            <ul className="space-y-2 text-sm text-background-200">
              <li><Link to="/a-propos" className="hover:text-primary-300 cursor-pointer">À propos</Link></li>
              <li><Link to="/a-propos#valeurs" className="hover:text-primary-300 cursor-pointer">Nos valeurs</Link></li>
              <li><Link to="/a-propos#equipe" className="hover:text-primary-300 cursor-pointer">Notre équipe</Link></li>
              <li><Link to="/contact" className="hover:text-primary-300 cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-primary-300 mt-1"></i>
                <div>
                  <div>info@godwin-logistics.com</div>
                  <div>sympho.kobabiya@godwin-logistics.com</div>
                  <div>blaise.mununga@godwin-logistics.com</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-primary-300 mt-1"></i>
                <div>
                  <div>+243 993 619 615</div>
                  <div>+243 891 281 032</div>
                  <div>+243 846 959 425</div>
                  <div>+243 999 209 934</div>
                  <div>+86 150 740 580 58 (Chine)</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-primary-300 mt-1"></i>
                <div>
                  Bâtiment AMAZON, 461 Av. des usines / Kapenda, 1er niveau, Lubumbashi RDC
                </div>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              {['facebook','linkedin','instagram','whatsapp'].map(s => (
                <a key={s} href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-primary-500 transition cursor-pointer">
                  <i className={`ri-${s}-fill text-white`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-background-300">
          <div>© 2026 Godwin Logistics & Services. Tous droits réservés.</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-primary-300 cursor-pointer">Mentions légales</a>
            <a href="#" className="hover:text-primary-300 cursor-pointer">Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}